import { useState, useEffect } from 'react';

const useMobile = () => {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        if (window.innerHeight <= 992) {
            setIsMobile(true);
        }
        else {
            setIsMobile(false);
        }
    }, []);

    return isMobile;
}

export default useMobile;